
/**
 * This utility detects special admin emails that should always have admin access
 * regardless of their database role setting.
 */

const SPECIAL_ADMIN_EMAILS = [
  'medinamarzaruth@gmail.com',
  'ruthmedinamarza@gmail.com',
  'kappaenne.web@gmail.com',
  'admin@guia-vegana.com',
  // Add other admin emails here
];

export const detectSpecialAdminEmails = (email: string): boolean => {
  if (!email) {
    console.log('🔍 detectSpecialAdminEmails: No email provided');
    return false;
  }
  
  const lowerEmail = email.toLowerCase();
  console.log('🔍 detectSpecialAdminEmails: Checking email:', lowerEmail);
  console.log('🔍 detectSpecialAdminEmails: Special admin emails:', SPECIAL_ADMIN_EMAILS);
  
  const isSpecialAdmin = SPECIAL_ADMIN_EMAILS.includes(lowerEmail);
  
  // Log for debugging
  if (isSpecialAdmin) {
    console.info(`✅ [AdminUtils] Special admin access granted to: ${email}`);
  } else {
    console.info(`❌ [AdminUtils] Email ${email} is not in special admin list`);
  }
  
  return isSpecialAdmin;
};

/**
 * Check if a user has permission to send notifications
 */
export const canSendNotifications = (email: string, role: string): boolean => {
  // Admins can always send notifications
  if (role === 'admin' || detectSpecialAdminEmails(email)) {
    return true;
  }
  
  return false;
};
